import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import routes from '../../routes/routes'

const SideNav = () => {
    return (
        <div className="leftpanel">
            <div className="media profile-left">
                <a className="pull-left profile-thumb" href="profile.html">
                    <img className="img-circle" src="images/photos/profile.png" alt="" />
                </a>
                <div className="media-body">
                    <h4 className="media-heading">Welcome</h4>
                    <small className="text-muted">Administrator</small>
                </div>
            </div>

            <h5 className="leftpanel-title">Navigation</h5>
            <ul className="nav nav-pills nav-stacked">
                <li>
                    <NavLink activeClassName="active" exact to={routes.public.home}>
                        <i className="fa fa-home" />
                        <span>
                            Dashboard
                        </span>
                    </NavLink>
                </li>
                <li className="parent active">
                    <Link to={routes.public.users}>
                        <i className="fa fa-users"></i>
                        <span>Manage Members</span>
                    </Link>
                    <ul className="children">
                        <li>
                            <NavLink activeClassName="active" exact to={routes.public.users} >
                                <i className="fa fa-users"></i>
                                <span>Members</span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink activeClassName="active" exact to={routes.public.createUser} >
                                <i className="fa fa-user"></i>
                                <span>Add Member</span>
                            </NavLink>
                        </li>
                    </ul>
                </li>
                <li className="parent active">
                    <Link to={routes.public.events}>
                        <i className="fa fa-trophy"></i>
                        <span>Events</span>
                    </Link>
                    <ul className="children">
                        <li>
                            <NavLink activeClassName="active" exact to={routes.public.events} >
                                <i className="fa fa-trophy"></i>
                                <span>All Events</span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink activeClassName="active" exact to={routes.public.addEvent} >
                                <i className="fa fa-tags"></i>
                                <span>Add Events</span>
                            </NavLink>
                        </li>

                    </ul>
                </li>

                <li className="parent active">
                    <Link to={routes.public.sections}>
                        <i className="fa fa-book"></i>
                        <span>Sections</span>
                    </Link>
                    <ul className="children">
                        <li>
                            <NavLink activeClassName="active" exact to={routes.public.sections} >
                                <i className="fa fa-book"></i>
                                <span>All Sections</span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink activeClassName="active" exact to={routes.public.addSection} >
                                <i className="fa fa-edit"></i>
                                <span>Add Section</span>
                            </NavLink>
                        </li>

                    </ul>
                </li>
                
                <li className="parent">
                    <NavLink activeClassName="active" exact to={routes.public.transactions} >
                        <i className="fa fa-file-text-o"></i>
                        <span>Transactions</span>
                    </NavLink>
                </li>

                <li className="parent active">
                    <Link to={routes.public.messageSectionMember}>
                        <i className="fa fa-bullhorn"></i>
                        <span>Communication</span>
                    </Link>
                    <ul className="children">
                        <li>
                            <NavLink to={routes.public.messageSectionMember}>
                                <i className="fa fa-bullhorn"></i>
                                <span>Sections</span>
                            </NavLink>
                        </li>
                    </ul>
                </li>
                <li className="parent">
                    <NavLink activeClassName="activeXX" exact to={routes.public.eVoting} >
                        <i className="fa fa-inbox"></i>
                        <span>E-Voting</span>
                    </NavLink>
                </li>
            </ul>
        </div>
    )
}

export default SideNav
